<template>
  <router-view name="priceAnalysis" v-bind:key="$route.path"></router-view>
</template>
<script>
export default {
  name: "PriceAnalysis",
};
</script>